export default __webpack_public_path__ + "static/edging-18fda1e07693b270f30476041c1d40c4.webp";